// What the assistant's cards say about this module, in the four languages:
// `sop.assistant.decision.*`. The backend sends the key and the English text
// (§16, backend/assistant.js); the card says it in the reader's language. Kept
// apart from index.js because it is a contract with that file: a key changed
// here is changed there.

export default {
  es: {
    decision: {
      summary: {
        plain: 'Registrar la decisión «{title}»',
        period: 'Registrar la decisión «{title}» para {period}',
      },
      action: 'Registrar una decisión del plan',
      field: { plan: 'Plan', title: 'Decisión', reason: 'Por qué', period: 'Periodo', impact: 'Efecto esperado' },
      value: { noPeriod: 'Todo el plan' },
      where: 'Plan S&OP',
      after: 'Queda escrita en el registro del plan; no cambia ninguna cifra',
      outcome: 'Decisión registrada: {title}',
    },
  },
  ca: {
    decision: {
      summary: {
        plain: 'Registrar la decisió «{title}»',
        period: 'Registrar la decisió «{title}» per a {period}',
      },
      action: 'Registrar una decisió del pla',
      field: { plan: 'Pla', title: 'Decisió', reason: 'Per què', period: 'Període', impact: 'Efecte esperat' },
      value: { noPeriod: 'Tot el pla' },
      where: 'Pla S&OP',
      after: 'Queda escrita al registre del pla; no canvia cap xifra',
      outcome: 'Decisió registrada: {title}',
    },
  },
  en: {
    decision: {
      summary: {
        plain: 'Record the decision “{title}”',
        period: 'Record the decision “{title}” for {period}',
      },
      action: 'Record a plan decision',
      field: { plan: 'Plan', title: 'Decision', reason: 'Why', period: 'Period', impact: 'Expected effect' },
      value: { noPeriod: 'The whole plan' },
      where: 'S&OP plan',
      after: 'Written in the plan’s log; no figure of the plan changes',
      outcome: 'Decision recorded: {title}',
    },
  },
  fr: {
    decision: {
      summary: {
        plain: 'Enregistrer la décision « {title} »',
        period: 'Enregistrer la décision « {title} » pour {period}',
      },
      action: 'Enregistrer une décision du plan',
      field: { plan: 'Plan', title: 'Décision', reason: 'Pourquoi', period: 'Période', impact: 'Effet attendu' },
      value: { noPeriod: 'Tout le plan' },
      where: 'Plan S&OP',
      after: 'Inscrite au journal du plan ; aucun chiffre du plan ne change',
      outcome: 'Décision enregistrée : {title}',
    },
  },
}
